<template>
    <div
        class="input-group"
        v-click-outside="onClickOutside"
        :aria-owns="listId"
        :aria-expanded="!!listShown ? 'true' : 'false'"
        @keydown.tab="isTabbed = true"
    >
        <div class="input-with-icon">
            <input
                id="suggest"
                type="text"
                class="form-control"
                :class="inputClasses"
                ref="inputElement"
                :placeholder="placeholder"
                :value="value && value.addressText"
                @blur="onBlur"
                @focus="onFocus"
                @input="onInput"
                @click="onClick"
                @keydown="onKeyDown"
                @keyup="onKeyUp"
            />
            <i class="icn-small-close" @click="onClear" v-if="value && value.addressText"></i>
        </div>
        <div class="custom-suggestions" v-if="!!listShown">
            <span class="custom-suggestions__label">
                Выберите вариант или продолжите ввод
            </span>
            <ul class="custom-suggestions__list">
                <li
                    v-for="sug in suggestions"
                    @click="onSuggestionClick(sug, $event)"
                    :aria-selected="isHovered(sug) || isSelected(sug) ? 'true' : 'false'"
                    :id="getId(sug)"
                    :key="getId(sug)"
                    :class="{
                        selected: isSelected(sug),
                        hovered: isHovered(sug),
                    }"
                    @mouseenter="setHovered(sug, $event.target)"
                    @mouseleave="setHovered({})"
                >
                    {{ sug.textBeforeMatch }}
                    <span>{{ sug.textMatch }}</span>
                    {{ sug.textAfterMatch }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {
    defaultControls,
    modes,
    hasKeyCodeByCode,
    hasKeyCode,
    splitSuggestion,
    strhash,
} from "./misc";

import _ from 'lodash';
import { querySuggestions } from "./api";
import YandexMap from "/../../MapPopup/src/YandexMap.vue";
import MapPopup from "/../../MapPopup/src/MapPopup.vue";

/**
 * Компонент для ввода адреса доставки
 * @prop value
 * @prop placeholder
 * @emits input {addressText, data}
 */
export default {
    name: "AddressInput",
    props: {
        cityKladr: {
            type: Object,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        value: {
            type: Object,
            required: true,
        },
        oClasses: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    components: { YandexMap, MapPopup },

    data() {
        return {
            selectedSuggestion: {},
            hoveredSuggestion: {},
            listId: `${this._uid}-suggestions`,
            listShown: false,
            controlScheme: {},
            isTabbed: false,
            clickedSuggestion: false,
            suggestions: [],
            oldSugs: false, // value изменилось, надо обновить.
        };
    },

    computed: {
        hoveredIndex() {
            for (let i = 0; i < this.suggestions.length; i++) {
                const sug = this.suggestions[i];
                if (sug.key == this.hoveredSuggestion.key) {
                    return i;
                }
            }
            return -1;
        },
        inputClasses() {
            return {
                ...this.oClasses
            }
        }
    },

    watch: {
        value(newValue, oldValue) {
            this.oldSugs = true;
        },
    },

    created() {
        this.controlScheme = Object.assign({}, defaultControls);
    },

    methods: {
        formatDadataFor1C(address) {
            const data = { ...address.data };
            let resultString = "";

            resultString += data.country ? data.country + ', ' : ',';
            resultString += data.postal_code ? data.postal_code + ', ' : ',';
            resultString += data.region ? data.region + ' ' + data.region_type + ', ' : ',';
            resultString += data.area ? data.area + ' ' + data.area_type + ', ' : ',';
            resultString += data.city ? data.city + ', ' : ',';
            resultString += data.settlement ? data.settlement + ', ' : ',';
            resultString += data.street ? data.street + ', ' : ',';
            resultString += data.house ? data.house + ', ' : ',';
            resultString += ',,';

            return { ...address, addressTextFor1C: resultString }
        },
      sendToGa(eventCategory, eventAction, orderWeight, basketItems) {
        if (
            (document.querySelector(".delivery-page") &&
                document.querySelector('[data-bs-target="#modal-shipment-cities"]')) ||
            document.querySelector(".address-form-input")
        ) {
          let dimension = {
            dimension7: window.dimension7,
            dimension11: window.dimension11,
            dimension15: localStorage.getItem("deliveryAddress")
                ? localStorage.getItem("deliveryAddress")
                : document.querySelector("#suggest").value,
          };
          if (orderWeight && basketItems) {
            dimension = {
              dimension7: window.dimension7,
              dimension9: orderWeight,
              dimension10: basketItems,
              dimension11: window.dimension11,
              dimension15: localStorage.getItem("deliveryAddress")
                  ? localStorage.getItem("deliveryAddress")
                  : document.querySelector("#suggest").value,
            };
          }
          gaPush.sendToGA("GAevent", eventCategory, eventAction, window.dimension11, dimension);
        }
      },
        isSelected(sug) {
            return sug.key == this.selectedSuggestion.key;
        },

        isHovered(sug) {
            return sug.key == this.hoveredSuggestion.key;
        },

        setSelected(item) {
            if (item.data && item.data.coords) {
                this.$root.$emit("yandex-map-emit-click", item.data.coords);
            }
            this.selectedSuggestion = this.formatDadataFor1C(item);
            this.$emit("input", this.selectedSuggestion);
            this.updateSuggestions(item.addressText, false);
        },

        setHovered(item) {
            const elemId = item.key ? this.getId(item) : "";
            this.$refs.inputElement.setAttribute("aria-activedescendant", elemId);
            this.hoveredSuggestion = item;
        },

        moveSelection(e) {
            if (!this.listShown || !this.suggestions.length) return;
            if (hasKeyCode([this.controlScheme.selectionUp, this.controlScheme.selectionDown], e)) {
                e.preventDefault();
                const isMovingDown = hasKeyCode(this.controlScheme.selectionDown, e);
                const direction = isMovingDown * 2 - 1;
                const listEdge = isMovingDown ? 0 : this.suggestions.length - 1;
                const hoversBetweenEdges = isMovingDown
                    ? this.hoveredIndex < this.suggestions.length - 1
                    : this.hoveredIndex > 0;
                let item = {};
                if (!this.hoveredSuggestion) {
                    item = this.selectedSuggestion || this.suggestions[listEdge];
                } else if (hoversBetweenEdges) {
                    item = this.suggestions[this.hoveredIndex + direction];
                } /* if hovers on edge */ else {
                    item = this.suggestions[listEdge];
                }
                this.setHovered(item);
            }
        },

        onKeyDown(e) {
            // console.log('onKeyDown', e);
            const select = this.controlScheme.select,
                hideList = this.controlScheme.hideList;
            // prevent form submit on keydown if Enter key registered in the keyup list
            if (e.key === "Enter" && this.listShown && hasKeyCodeByCode([select, hideList], 13)) {
                e.preventDefault();
            }
            /* TODO: Tab key handling
      if (e.key === 'Tab' && this.hoveredSuggestion) {
        this.setSelected(this.hoveredSuggestion);
      }*/
            if (this.listShown) {
                /// Enter etc..
                if (hasKeyCode(select, e)) {
                    // Если на что-нибудь наведено
                    if (this.hoveredSuggestion.addressText) {
                        this.setSelected(this.hoveredSuggestion);
                        this.hideSuggestions();
                    }
                } else if (hasKeyCode(hideList, e)) {
                    this.hideSuggestions();
                } else {
                    this.moveSelection(e);
                }
            } else if (
                this.value &&
                this.value.addressText &&
                this.value.addressText.length > 3 &&
                /** Стрелки вверх, вниз и Enter */
                hasKeyCode(
                    [
                        this.controlScheme.selectionUp,
                        this.controlScheme.selectionDown,
                        this.controlScheme.select,
                    ],
                    e
                )
            ) {
                if (this.suggestions.length == 0 || this.oldSugs) {
                    // Обновить и показать
                    this.updateSuggestions(this.value.addressText);
                } else {
                    // показать, какие есть
                    this.displaySuggestions();
                }
            }
        },

        /** Выбор из списка */
        onKeyUp(e) {},

        getId(value) {
            return `${this.listId}-suggestion-${value.key}`;
        },

        onSuggestionClick(sug, e) {
            this.setSelected(this.hoveredSuggestion);
            this.setHovered({});
            this.hideSuggestions();
            this.clickedSuggestion = true;
            // console.log('onSuggestionClick');
            this.$refs.inputElement.focus();

            if(document.querySelector('[data-bs-target="#modal-shipment-cities"]')) {
              this.sendToGa('delivery','inputAddressDropdown');
            } else if(document.querySelector('.address-form-input')) {
              this.sendToGa('order','deliveryAddressDropdown', (window.VOrderComponent.total.ORDER_WEIGHT/1000).toFixed(3), window.basketItems);
            }

        },

        /**
         * Текст изменился, после выбора или после ввода.
         * @param e
         */
        onInput(e) {
            // console.log('onInput', e);
            const inputText = e.target.value;
            this.updateSuggestions(inputText);
            /** В таком случае есть только адрес, возможно, несуществующий. */
            this.$emit("input", { addressText: inputText, data: null });
        },

        /**
         * Фокус поля ввода.
         * TODO: new
         */
        onFocus(e) {
            // console.log('onFocus');
            /// check for not a refocus.
            if (this.clickedSuggestion) {
                this.clickedSuggestion = false;
                return;
            }
            if (this.value && this.value.addressText && this.value.addressText.length > 3) {
                if (this.suggestions.length == 0 || this.oldSugs) {
                    this.updateSuggestions(this.value.addressText);
                } else {
                    this.displaySuggestions();
                }
            }
        },

        /**
         * Поле потеряло фокус
         * */
        onBlur(e) {
            /** Учитывать, что потеря фокуса связана с выбором из списка
             * blur происходит перед другими: blur, click, refocus
             * */
            // console.log('onBlur');
            // this.is = this.hovered && !this.isTabbed
            // if (this.isClicking) {
            //   this.isFalseFocus = true
            // } else if (e && e.isTrusted && !this.isTabbed) {
            //   this.isInFocus = false
            //   this.hideList()
            // }
            if (e && e.isTrusted && !this.isTabbed && !this.hoveredSuggestion.key) {
                this.hideSuggestions();
            }
        },

        /**
         * Отобразить список адресов
         * */
        displaySuggestions() {
            if (this.suggestions.length > 0) {
                this.listShown = true;
            } else {
                this.listShown = false;
            }
        },

        hideSuggestions() {
            this.listShown = false;
        },

        updateSuggestions: _.debounce(async function(inputText, display = true) {
            // console.log('updateSuggestions');
            if (!inputText || inputText.length < 3) {
                this.hideSuggestions();
                return;
            }
            try {
                const sugs = await querySuggestions({
                    inputText: inputText + ' ',
                    cityKladr: this.cityKladr,
                    from_bound: { value: "country" },
                    to_bound: { value: "house" }
                });

                for (const sug of sugs) {
                    const split = splitSuggestion(sug.addressText, inputText);
                    if (split.length == 3) {
                        sug.textBeforeMatch = split[0];
                        sug.textMatch = split[1];
                        sug.textAfterMatch = split[2];
                    } else {
                        sug.textBeforeMatch = sug.addressText;
                    }
                    sug.data.coords = [sug.data.geo_lat, sug.data.geo_lon];
                    sug.key = `${sug.data.geo_lat}-${sug.data.geo_lon}-${strhash(
                        sug.addressText
                    )}`.replaceAll(".", "_");
                }

                this.suggestions = sugs;
                this.oldSugs = false;
                if (display) this.displaySuggestions();
            } catch (e) {
                console.error(e);
            }
        }, 600),

        onClickOutside(e) {
            this.hideSuggestions();
        },

        /**
         * Просто клик на input
         */
        onClick(e) {
            if (e.target.tagName == "INPUT") this.displaySuggestions();
            if (document.querySelector('[data-bs-target="#modal-shipment-cities"]')) {
              this.sendToGa("delivery", "inputAddressClick");
            } else if (document.querySelector(".address-form-input")) {
              this.sendToGa("order", "deliveryAddressClick");
            }
        },

        onClear() {
            this.$emit("input", { addressText: "", data: null });
            this.suggestions = [];
            this.selectedSuggestion = this.hoveredSuggestion = {};
            this.hideSuggestions();
            this.clickedSuggestion = true; // Чтобы обработчик onFocus ничего не делал
            this.$refs.inputElement.focus();
            if (document.querySelector('[data-bs-target="#modal-shipment-cities"]')) {
              this.sendToGa("delivery", "inputAddressDel");
            }
        },
    },

    mounted() {
        this.$refs.inputElement.setAttribute("aria-activedescendant", "");
        this.$refs.inputElement.setAttribute("aria-autocomplete", "list");
        this.$refs.inputElement.setAttribute("aria-controls", this.listId);
    },
};
</script>

<style scoped>
.icn-small-close {
    font-weight: bold;
}

span.custom-suggestions__label {
    padding-bottom: 2px;
}

.custom-suggestions {
    display: block;
    padding: 8px 0;
    margin-left: 0 !important;
    margin-top: -1px;
    z-index: 55;
}

/* Отмена */
.custom-suggestions__list li:hover {
    background-color: white;
}

.custom-suggestions__list li.hovered {
    background-color: #fde3ab;
}

.custom-suggestions__list li.selected {
    background-color: #fde3ab;
    font-weight: 500;
}

.pr-8 {
    padding-right: 8px !important;
}
</style>
